import React from 'react';
import { CheckCircle2, CircleAlert, Phone } from 'lucide-react';
const accepted = ['Household junk', 'Renovation debris', 'Furniture', 'Yard waste', 'Construction materials'];
const prohibited = ['Paint & chemicals', 'Tires', 'Batteries', 'Propane tanks', 'Hazardous waste'];
export function MaterialsSection() {
  return <section id="materials" className="w-full bg-background py-16 md:py-24" data-id="element-275">
      <div className="container" data-id="element-276">
        <div className="mx-auto max-w-2xl text-center" data-id="element-277">
          <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl" data-id="element-278">
            Know what goes in
          </h2>
          <p className="mt-3 text-muted-foreground" data-id="element-279">
            A quick guide to common materials before you reserve your dumpster.
          </p>
        </div>
        <div className="mx-auto mt-10 grid max-w-4xl gap-5 md:grid-cols-2" data-id="element-280">
          <article className="rounded-xl border border-border bg-card p-6" data-id="element-281">
            <div className="flex items-center gap-3" data-id="element-282">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary" data-id="element-283">
                <CheckCircle2 className="h-5 w-5" data-id="element-284" />
              </span>
              <div data-id="element-285">
                <h3 className="font-semibold text-card-foreground" data-id="element-286">
                  What we take
                </h3>
                <p className="text-sm text-muted-foreground" data-id="element-287">
                  Everyday project and cleanup debris.
                </p>
              </div>
            </div>
            <ul className="mt-5 grid gap-3 text-sm text-muted-foreground sm:grid-cols-2" data-id="element-288">
              {accepted.map(item => <li key={item} className="flex items-center gap-2" data-id="element-289">
                  <CheckCircle2 className="h-4 w-4 shrink-0 text-primary" data-id="element-290" />
                  {item}
                </li>)}
            </ul>
          </article>
          <article className="rounded-xl border border-border bg-secondary/40 p-6" data-id="element-291">
            <div className="flex items-center gap-3" data-id="element-292">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-foreground/10 text-foreground" data-id="element-293">
                <CircleAlert className="h-5 w-5" data-id="element-294" />
              </span>
              <div data-id="element-295">
                <h3 className="font-semibold text-foreground" data-id="element-296">
                  What we can’t take
                </h3>
                <p className="text-sm text-muted-foreground" data-id="element-297">
                  Items requiring special handling.
                </p>
              </div>
            </div>
            <ul className="mt-5 grid gap-3 text-sm text-muted-foreground sm:grid-cols-2" data-id="element-298">
              {prohibited.map(item => <li key={item} className="flex items-center gap-2" data-id="element-299">
                  <CircleAlert className="h-4 w-4 shrink-0 text-muted-foreground" data-id="element-300" />
                  {item}
                </li>)}
            </ul>
          </article>
        </div>
        <p className="mt-6 flex items-center justify-center gap-2 text-center text-sm text-muted-foreground" data-id="element-301">
          <Phone className="h-4 w-4 text-primary" data-id="element-302" />
          Questions about a material? Call us before you load it.
        </p>
      </div>
    </section>;
}